// angular
// .module("HeroPRO")
// .controller("QuestionsController", questionsController);

import _ from 'lodash';
import './questions.scss';

/* @ngInject */
export default function questionsController(AdvancedRegistrationFactory) {
    const vm = this;
    vm.questions = null;
    vm.invalidAnswers = false;
    vm.globalError = 'You must answer all questions before proceeding.';

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.setAnswer = function (question, selectedAnswer) {
        question.selectedAnswer = selectedAnswer;
    };
    vm.submitAnswers = function () {
        vm.invalidAnswers = false;
        validateAnswers();

        if (vm.idVerifyQuestionsForm.$valid) {
            const params = {
                PersonIdentityId: AdvancedRegistrationFactory.getPersonIdentityId(),
                ContractorUserId: AdvancedRegistrationFactory.getContractorUserId(),
                IdNumber: AdvancedRegistrationFactory.getIdNumber(),
                isAutoIDV: false,
            };

            _.each(vm.questions, (question, index) => {
                params[`Question${index + 1}Type`] = question.Type;
                params[`Question${index + 1}Answer`] = question.selectedAnswer;
            });

            AdvancedRegistrationFactory.completeAdvancedRegistration(params).then((response) => {

                if (!!response.data.Data.Result 
                    && !!response.data.Data.Result.ResponseInfo
                    && !!response.data.Data.Result.ResponseInfo.IdLiveQResult
                    && !!response.data.Data.Result.ResponseInfo.IdLiveQResult.Key
                    && response.data.Data.Result.ResponseInfo.IdLiveQResult.Key === 3) {
                    // PASS
                    const params = {
                        // Hardcoding needs to be changed to a dynamic value once
                        // the API is returning the ActionItemTypeConfigurationId
                        ActionItemTypeConfigurationId: 32,
                    };

                    AdvancedRegistrationFactory.completeAdvancedRegActionItem(params).then(() => {
                        AdvancedRegistrationFactory.setVisiblePages(['success']);
                    });
                } else {
                    // FAIL
                    vm.invalidAnswers = true;
                    vm.idVerifyQuestionsForm.$submitted = false;
                    vm.idVerifyQuestionsForm.$valid = true;

                    const autoIDVParams = {
                        IdVerifyInfo: {
                            FirstName: vm.personalInfo.ownerFirstName,
                            LastName: vm.personalInfo.ownerLastName,
                            Address: vm.personalInfo.ownerAddress1,
                            City: vm.personalInfo.ownerCityName,
                            State: vm.personalInfo.ownerState,
                            Zip: vm.personalInfo.ownerZipcode,
                            SsnLast4: vm.personalInfo.ownerSSN,
                            DobDay: vm.personalInfo.ownerDOBDay,
                            DobMonth: vm.personalInfo.ownerDOBMonth,
                            DobYear: vm.personalInfo.ownerDOBYear,
                        },
                        PersonIdentityId: null,
                        Email: vm.personalInfo.ownerEmail,
                        MobilePhone: vm.personalInfo.ownerPhone,
                    };

                    AdvancedRegistrationFactory.attempAutoIDV(autoIDVParams).then((response) => {
                        if (response.data.Data.Status === 3 && response.data.Data.ErrorMessage === 'Too many attempts within 24 hours') {
                            // FAIL, TOO MANY ATTEMPTS
                            AdvancedRegistrationFactory.setVisiblePages(['uploadId']);
                        } else if (!!response.data.Data.Questions 
                                && !!response.data.Data.Questions.ResponseInfo 
                                && !!response.data.Data.Questions.ResponseInfo.IdNumber 
                                && !!response.data.Data.Questions.ResponseInfo.Questions) {
                            // FAIL, FOUND
                            var questions = response.data.Data.Questions.ResponseInfo.Questions;
                            AdvancedRegistrationFactory.setIdNumber(response.data.Data.Questions.ResponseInfo.IdNumber);
                            AdvancedRegistrationFactory.setQuestions(
                                (!!questions && questions.length > 0) ? questions : null
                            );
                            init();
                        }
                    });
                }
            });
        }
    };
    /* -----  End of Public Functions  ------*/


    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        vm.questions = AdvancedRegistrationFactory.getQuestions();
        vm.personalInfo = AdvancedRegistrationFactory.getPersonalInfo();

        _.each(vm.questions, (question) => {
            question.selectedAnswer = null;
        });
    }

    function validateAnswers() {
        const isFormValid = _.every(vm.questions, question => question.selectedAnswer !== null);

        if (isFormValid === true) {
            vm.idVerifyQuestionsForm.$setValidity('questionsAnswered', true);
        } else {
            vm.idVerifyQuestionsForm.$setValidity('questionsAnswered', false);
        }
    }
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/templates/advancedRegistration/questions/questionsController.js